import React, { useState, useRef, useEffect } from "react";
import Person from "../assets/Person.png";
import { useTranslation } from "react-i18next";

const GuestCounter = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);

  const wrapperRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleIncrease = (type) => {
    if (type === "adults") setAdults((prev) => prev + 1);
    if (type === "children") setChildren((prev) => prev + 1);
  };

  const handleDecrease = (type) => {
    if (type === "adults" && adults > 1) setAdults((prev) => prev - 1);
    if (type === "children" && children > 0) setChildren((prev) => prev - 1);
  };

  return (
    <div className="person-box btn-border-box position-relative" ref={wrapperRef}>
      {/* Summary (clickable) */}
      <div
        className="bottom-div d-flex align-items-center gap-1 dropdown-custom cursor-pointer"
        onClick={() => setShow(!show)}
      >
        <div className="left-icons">
          <img src={Person} alt={t("Travelers")} />
        </div>
        <div className="right-calendar-details">
          <p>{t("Travelers")}</p>
          <h5>
            {adults} {t("Adult")}{adults > 1 ? t("s") : ""}, {children} {t("Child")}{children !== 1 ? t("ren") : ""}
          </h5>
        </div>
      </div>

      {/* Dropdown */}
      {show && (
        <div className="guest-counter position-absolute bg-white shadow p-3 rounded mt-2">
          {/* Adults */}
          <div className="counter-row d-flex justify-content-between align-items-center mb-2">
            <div className="label">
              <strong>{t("Adults")}</strong>
              <div className="sub-text">{t("Age 18+")}</div>
            </div>
            <div className="controls d-flex align-items-center gap-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => handleDecrease("adults")}
                disabled={adults <= 1}
              >
                -
              </button>
              <span className="count">{adults}</span>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => handleIncrease("adults")}
              >
                +
              </button>
            </div>
          </div>

          {/* Children */}
          <div className="counter-row d-flex justify-content-between align-items-center">
            <div className="label">
              <strong>{t("Children")}</strong>
              <div className="sub-text">{t("Age 0–17")}</div>
            </div>
            <div className="controls d-flex align-items-center gap-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => handleDecrease("children")}
                disabled={children <= 0}
              >
                -
              </button>
              <span className="count">{children}</span>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => handleIncrease("children")}
              >
                +
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GuestCounter;
